import React from "react";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import { getRouterLinkUrl } from "helpers/routes";
import { useBranding } from "hooks/useBranding";

import type { FeatureRouteProps } from "types/navigation";

const StyledInfoOrderedList = styled.ol`
  list-style: decimal inside;
  margin-top: ${(props) => props.theme.spacing.small};
`;

const HELP_ARTICLE_URL =
  "https://help.upserve.com/s/article/Providing-Users-With-Access-to-Workforce";

function WorkforceGettingStartedContent({
  match: {
    params: { vendorLevel, vendorLocation },
  },
}: FeatureRouteProps) {
  const branding = useBranding("U-Series");
  const rolesUrl = getRouterLinkUrl(
    vendorLevel,
    vendorLocation,
    "users",
    "roles",
    "pos"
  );

  return (
    <div>
      Oops, it looks like this user does not have permissions to manage
      schedules.
      <StyledInfoOrderedList>
        <li>
          {"To set them up, follow the instructions in "}
          <a href={HELP_ARTICLE_URL} target="_blank" rel="noreferrer">
            {branding} Support Center
          </a>
          .
        </li>
        <li>
          Click <Link to={rolesUrl}>here</Link> to edit the roles and assign the
          permissions.
        </li>
        <li>
          Return to this page to start scheduling. Note: you may have to reload.
        </li>
      </StyledInfoOrderedList>
    </div>
  );
}

export default withRouter(WorkforceGettingStartedContent);
